import UploadFile from "./uploadFile";

export default UploadFile;